module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/chowbus_logo_text_white-92f15231e6e919cdc31edf10a86999cb.png";